export class Config {
  apiSecuritySeven: string;
  apiSecurityKactus: string;
  apiMicroApplicationsSeven: string;
  apiMainSeven: string;
  apiProcessTable: string;
  apiMainKactus: string;
  timeInactivity: number;
  designerCode:string;
  urlReportingServices:string;
  urlReportServer: string;
  urlReportCrytal: string;
  urlAyudaenlinea: string;
  urImperium: string;
  loginAgora: string;
  apicaptcha: string;
  urlchatIAfinance: string;
}
